export default __webpack_public_path__ + "static/media/B-Tonight.8ba59e3e.jpg";